/* Capital Kidz - Luna personal-shopper, two-pane "showroom" UI (vanilla).
   LEFT: chat with Luna (text, tappable quick replies, composer).
   RIGHT: live showroom - recommended products, compare, bundle, shortlist tray,
   email picks. Products are routed to the showroom; the chat stays conversation.
   All product data comes validated (live + in stock) from the Worker. */
(function () {
  'use strict';
  if (window.__ckOwnerAnalyticsOptOutReady) return;
  window.__ckOwnerAnalyticsOptOutReady = true;

  var paramName = 'ck_owner';
  var storageKey = 'ck_owner_no_analytics';
  var cookieName = 'ck_owner_no_analytics';
  var oneYear = 60 * 60 * 24 * 365;

  function readCookie() {
    return document.cookie.split(';').some(function (cookie) {
      return cookie.trim() === cookieName + '=1';
    });
  }

  function writeCookie(enabled) {
    document.cookie = cookieName + '=' + (enabled ? '1' : '') +
      '; path=/; max-age=' + (enabled ? oneYear : '0') + '; SameSite=Lax';
  }

  function setStorage(enabled) {
    try {
      if (enabled) {
        window.localStorage.setItem(storageKey, '1');
      } else {
        window.localStorage.removeItem(storageKey);
      }
    } catch (error) {}
  }

  function readStorage() {
    try {
      return window.localStorage.getItem(storageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function cleanUrl(params) {
    if (!window.history || !window.history.replaceState) return;
    params.delete(paramName);
    var query = params.toString();
    var nextUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    window.history.replaceState(null, '', nextUrl);
  }

  var params = new URLSearchParams(window.location.search);
  var ownerMode = params.get(paramName);

  if (ownerMode === '1') {
    setStorage(true);
    writeCookie(true);
    cleanUrl(params);
  } else if (ownerMode === '0') {
    setStorage(false);
    writeCookie(false);
    cleanUrl(params);
  }

  if (!(readStorage() || readCookie())) return;

  window.__ckOwnerAnalyticsBlocked = true;

  function shouldBlockAnalytics(urlLike) {
    var rawUrl = '';

    if (typeof urlLike === 'string') {
      rawUrl = urlLike;
    } else if (urlLike && typeof urlLike.url === 'string') {
      rawUrl = urlLike.url;
    } else if (urlLike && typeof urlLike.toString === 'function') {
      rawUrl = urlLike.toString();
    }

    if (!rawUrl) return false;

    try {
      var url = new URL(rawUrl, window.location.origin);
      return url.hostname === 'monorail-edge.shopifysvc.com' ||
        url.pathname.indexOf('/cdn/s/trekkie.storefront') !== -1 ||
        url.pathname.indexOf('/shopifycloud/web-pixels-manager') !== -1 ||
        url.pathname.indexOf('/shop_events_listener-') !== -1;
    } catch (error) {
      return false;
    }
  }

  if (window.navigator && typeof window.navigator.sendBeacon === 'function') {
    var nativeSendBeacon = window.navigator.sendBeacon.bind(window.navigator);
    window.navigator.sendBeacon = function (url, data) {
      if (shouldBlockAnalytics(url)) return true;
      return nativeSendBeacon(url, data);
    };
  }

  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      if (shouldBlockAnalytics(input)) {
        return Promise.resolve(new Response('', { status: 204, statusText: 'Owner analytics opt-out' }));
      }
      return nativeFetch(input, init);
    };
  }

  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
    var nativeOpen = window.XMLHttpRequest.prototype.open;
    var nativeSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__ckBlockAnalytics = shouldBlockAnalytics(url);
      if (this.__ckBlockAnalytics) return;
      return nativeOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (this.__ckBlockAnalytics) return;
      return nativeSend.apply(this, arguments);
    };
  }
})();

(function () {
  'use strict';
  if (window.__ckLunaLoaded) return; // guard: script may be included by both the page section and the launcher
  window.__ckLunaLoaded = true;

  var LUNA_SESSION_KEY = 'ckLunaSessionId';
  var LUNA_RECENT_TOUCH_KEY = 'ckLunaRecentTouch';
  var LUNA_TOUCH_TTL = 24 * 60 * 60 * 1000;
  function lunaSessionId() {
    try {
      var existing = localStorage.getItem(LUNA_SESSION_KEY);
      if (existing) return existing;
      var id = 'luna_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
      localStorage.setItem(LUNA_SESSION_KEY, id);
      return id;
    } catch (e) {
      return 'luna_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
    }
  }
  var lunaSid = lunaSessionId();
  window.__ckLunaTrackBase = window.__ckLunaTrackBase || '';
  window.ckLunaTrack = window.ckLunaTrack || function (event, data) {
    data = data || {};
    var payload = Object.assign({
      event: event,
      session_id: lunaSid,
      path: location.pathname,
      referrer: document.referrer || '',
      surface: data.surface || 'personal_shopper',
      device: window.innerWidth <= 900 ? 'mobile' : 'desktop'
    }, data);
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'ck_luna_' + event, luna: payload });
      if (typeof window.gtag === 'function') window.gtag('event', 'ck_luna_' + event, payload);
    } catch (e) {}
    var base = (window.__ckLunaTrackBase || '').replace(/\/$/, '');
    if (!base) return;
    try {
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon(base + '/luna/track', blob)) return;
      }
      fetch(base + '/luna/track', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {});
    } catch (e2) {}
  };

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (k.indexOf('on') === 0 && typeof attrs[k] === 'function') n.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null) n.setAttribute(k, attrs[k]);
    }
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }

  window.ckGetShopifyInboxToggle = window.ckGetShopifyInboxToggle || function (chat) {
    if (!chat || !chat.shadowRoot) return null;
    var selector = '[data-spec="toggle-button"], .chat-toggle, button.activator[aria-expanded], button[aria-label="Live chat"][aria-expanded]';
    var toggle = chat.shadowRoot.querySelector(selector);
    if (toggle) return toggle;
    var runtime = chat.shadowRoot.querySelector('shopify-agent-runtime');
    return runtime && runtime.shadowRoot ? runtime.shadowRoot.querySelector(selector) : null;
  };

  window.ckOpenShopifyInbox = window.ckOpenShopifyInbox || function () {
    var chat = document.querySelector('#ShopifyChat, inbox-online-store-chat, shopify-chat, shopify-agent');
    if (!chat) return false;
    var toggle = window.ckGetShopifyInboxToggle(chat);
    if (toggle) toggle.click();
    else chat.click();
    return true;
  };

  var lunaMarkHtml = '<svg class="ck-ps__mark" viewBox="0 0 24 24" width="16" height="16" focusable="false" aria-hidden="true"><path d="M16.7 3.2a8.5 8.5 0 1 0 4.1 13.9 6.8 6.8 0 1 1-4.1-13.9z" fill="currentColor"/></svg>';

  // Minimal, safe markdown for Luna's chat (bold, italic, headings, lists, and absolute web links).
  function mdEmphasis(s) {
    return s
      .replace(/\*\*["“”]([^*]+?)["“”]\*\*/g, '<strong>$1</strong>')
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1<em>$2</em>');
  }
  function mdInline(s) {
    var links = [];
    var protectedText = s.replace(/\[([^\]\n]+)\]\((https?:\/\/[^\s<>"']+)\)/gi, function (_match, label, url) {
      var token = '\u0000CKLINK' + links.length + '\u0000';
      links.push('<a class="ck-ps__link" href="' + url + '" target="_blank" rel="noopener noreferrer" style="text-decoration:underline;text-underline-offset:2px;font-weight:600">' + mdEmphasis(label) + '</a>');
      return token;
    });
    return mdEmphasis(protectedText).replace(/\u0000CKLINK(\d+)\u0000/g, function (_match, index) {
      return links[Number(index)] || '';
    });
  }
  function mdToHtml(s) {
    var esc = (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return esc.split('\n').map(function (line) {
      if (!line.trim()) return '<div class="ck-ps__sp"></div>';
      var h = line.match(/^\s*#{1,6}\s+(.*)$/);
      if (h) return '<div class="ck-ps__h">' + mdInline(h[1]) + '</div>';
      var b = line.match(/^\s*[-*]\s+(.*)$/);
      if (b) return '<div class="ck-ps__li"><span class="ck-ps__dot">&bull;</span><span>' + mdInline(b[1]) + '</span></div>';
      var n = line.match(/^\s*(\d+)[.)]\s+(.*)$/);
      if (n) return '<div class="ck-ps__num"><span class="ck-ps__numidx">' + n[1] + '</span><span>' + mdInline(n[2]) + '</span></div>';
      return '<div>' + mdInline(line) + '</div>';
    }).join('');
  }

  function initRoot(root) {
    if (root.__ckInit) return; // guard: only initialize each concierge root once
    root.__ckInit = true;
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-ps-config]').textContent); } catch (e) {}
    var base = (cfg.workerUrl || '').replace(/\/$/, '');
    if (base && !window.__ckLunaTrackBase) window.__ckLunaTrackBase = base;

    var log = root.querySelector('[data-ps-log]');
    var form = root.querySelector('[data-ps-form]');
    var input = root.querySelector('[data-ps-input]');
    var send = root.querySelector('[data-ps-send]');
    var suggestWrap = root.querySelector('[data-ps-suggest]');
    var show = root.querySelector('[data-ps-show]');
    var tray = root.querySelector('[data-ps-tray]');
    var showTitle = root.querySelector('[data-ps-show-title]');
    var showMeta = root.querySelector('[data-ps-show-meta]');
    var showCol = show ? show.closest('.ck-ps__showcol') : null;

    var messages = [];
    var busy = false;
    var currentQuick = null;
    var shortlist = [];      // collected recommended products (dedup by handle)
    var lastMatches = [];    // most recent "matches" set, for back-navigation
    var mobileCardsShownForTurn = false;
    var surface = root.closest('[data-ck-luna]') ? 'drawer' : 'page';
    var internalCartAddUntil = 0;
    var lastExternalCartMark = 0;
    window.ckLunaTrack('seen', { surface: surface });

    // ---- cross-visit memory (localStorage) ----
    var STORAGE_KEY = 'ckps:v1';
    function save() {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ shortlist: shortlist, messages: messages.slice(-16), lastMatches: lastMatches, ts: Date.now() })); } catch (e) {}
    }
    function loadSaved() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var s = JSON.parse(raw);
        if (!s || !s.shortlist || !s.shortlist.length) return null;
        if (s.ts && Date.now() - s.ts > 21 * 864e5) return null; // expire after 21 days
        return s;
      } catch (e) { return null; }
    }

    // ---- Turnstile (optional) ----
    var turnstileToken = '';
    var tsEl = root.querySelector('[data-ps-turnstile]');
    if (cfg.turnstileSitekey && tsEl) {
      var poll = setInterval(function () {
        if (window.turnstile) { clearInterval(poll); try { window.turnstile.render(tsEl, { sitekey: cfg.turnstileSitekey, callback: function (t) { turnstileToken = t; } }); } catch (e) {} }
      }, 250);
      setTimeout(function () { clearInterval(poll); }, 8000);
    }

    // ===================== CHAT (left) =====================
    function chatScroll() { log.scrollTop = log.scrollHeight; }
    function avatar(small) {
      return el('div', { class: 'ck-ps__avatar' + (small ? ' ck-ps__avatar--sm' : ''), 'aria-hidden': 'true', html: lunaMarkHtml });
    }
    function addMsg(role, text) {
      var bubble = el('div', { class: 'ck-ps__bubble', text: text || '' });
      var kids = role === 'user' ? [bubble] : [avatar(true), el('div', { class: 'ck-ps__botstack' }, [bubble])];
      log.appendChild(el('div', { class: 'ck-ps__msg ck-ps__msg--' + (role === 'user' ? 'user' : 'bot') }, kids));
      chatScroll();
      return bubble;
    }
    function compactMessage(m) {
      return { role: m.role === 'assistant' ? 'assistant' : 'user', content: String(m.content || '').slice(0, 900) };
    }
    function feedbackPayload(rating, reason, answerText) {
      var lastUser = '';
      for (var i = messages.length - 1; i >= 0; i -= 1) {
        if (messages[i] && messages[i].role === 'user') { lastUser = messages[i].content || ''; break; }
      }
      return {
        rating: rating,
        reason: reason || (rating === 'positive' ? 'helpful' : 'unspecified'),
        session_id: lunaSid,
        surface: surface,
        device: window.innerWidth <= 900 ? 'mobile' : 'desktop',
        path: location.pathname,
        last_user_message: lastUser,
        assistant_answer: answerText || '',
        messages: messages.slice(-8).map(compactMessage),
        products: lastMatches.slice(0, 8).map(productPayload)
      };
    }
    function postFeedback(row, rating, reason, answerText) {
      if (!base) return;
      var payload = feedbackPayload(rating, reason, answerText);
      row.classList.add('is-sent');
      row.innerHTML = '';
      row.appendChild(el('span', { text: rating === 'positive' ? 'Thanks - Luna will learn from this.' : 'Got it - this goes into Luna review.' }));
      try {
        var body = JSON.stringify(payload);
        if (navigator.sendBeacon) {
          var blob = new Blob([body], { type: 'application/json' });
          if (navigator.sendBeacon(base + '/luna/feedback', blob)) return;
        }
        fetch(base + '/luna/feedback', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {});
      } catch (e) {}
    }
    function showFeedbackReasons(row, answerText) {
      row.innerHTML = '';
      [
        ['Wrong item', 'wrong_product'],
        ['Bad format', 'bad_format'],
        ['Not helpful', 'not_helpful'],
        ['Safety concern', 'safety_concern']
      ].forEach(function (item) {
        row.appendChild(el('button', { class: 'ck-ps__feedbackbtn', type: 'button', text: item[0], onclick: function () { postFeedback(row, 'negative', item[1], answerText); } }));
      });
    }
    function addFeedbackControls(bubble, answerText) {
      if (!bubble || !bubble.parentNode || !base) return;
      var row = el('div', { class: 'ck-ps__feedback', 'aria-label': 'Rate Luna response' }, [
        el('button', { class: 'ck-ps__feedbackbtn', type: 'button', text: 'Helpful', onclick: function () { postFeedback(row, 'positive', 'helpful', answerText); } }),
        el('button', { class: 'ck-ps__feedbackbtn ck-ps__feedbackbtn--bad', type: 'button', text: 'Bad answer', onclick: function () { showFeedbackReasons(row, answerText); } })
      ]);
      bubble.parentNode.appendChild(row);
      chatScroll();
    }
    function addTyping() {
      var t = el('div', { class: 'ck-ps__msg ck-ps__msg--bot' }, [
        avatar(true),
        el('div', { class: 'ck-ps__bubble' }, [el('span', { class: 'ck-ps__typing' }, [el('span'), el('span'), el('span')])]),
      ]);
      log.appendChild(t); chatScroll(); return t;
    }
    function renderQuickReplies(options) {
      if (!options.length) return;
      if (currentQuick) { currentQuick.remove(); currentQuick = null; }
      currentQuick = el('div', { class: 'ck-ps__quick' }, options.map(function (o) {
        return el('button', { class: 'ck-ps__chip', type: 'button', text: o, onclick: function () { window.ckLunaTrack('quick_reply', { surface: surface, choice: o }); sendMessage(o); } });
      }));
      log.appendChild(currentQuick); chatScroll();
    }
    function renderHandoff(data) {
      var url = (data && data.url) || cfg.handoffUrl || '/pages/contact-us';
      function openHumanChat(e) {
        e.preventDefault();
        window.ckLunaTrack('handoff_clicked', { surface: surface });
        if (window.ckOpenShopifyInbox && document.querySelector('#ShopifyChat, inbox-online-store-chat, shopify-chat, shopify-agent')) {
          var lunaRoot = root.closest('[data-ck-luna]');
          var closeBtn = lunaRoot && lunaRoot.querySelector('[data-luna-close]');
          if (closeBtn) closeBtn.click();
          setTimeout(function () { window.ckOpenShopifyInbox(); }, 180);
          return;
        }
        window.location.href = url;
      }
      log.appendChild(el('div', { class: 'ck-ps__handoff' }, [
        el('span', { class: 'ck-ps__handoff-ic', 'aria-hidden': 'true', html: lunaMarkHtml }),
        el('div', {}, [el('strong', { text: 'Talk to a real expert' }), el('button', { class: 'ck-ps__handoff-action', type: 'button', onclick: openHumanChat, text: 'Open live chat' })]),
      ]));
      chatScroll();
    }

    // ===================== SHOWROOM (right) =====================
    function setHead(title, meta) { if (showTitle) showTitle.textContent = title; if (showMeta) showMeta.textContent = meta || ''; }
    function setShowroomReady(ready) { if (showCol) showCol.classList.toggle('ck-ps__showcol--empty', !ready); }
    function clearShow() { show.innerHTML = ''; }
    function defaultVariant(c) { var v = (c.variants || []).filter(function (x) { return x.available; }); return v[0] || (c.variants || [])[0] || null; }
    function productPayload(card) {
      var v = card && (card._variant || defaultVariant(card));
      return {
        surface: surface,
        handle: card && card.handle,
        title: card && card.title,
        vendor: card && card.vendor,
        price: card && card.price,
        variant_id: v && v.variantId
      };
    }
    function productUrl(url) { return url || '#'; }
    function rememberLunaTouch(card) {
      try {
        localStorage.setItem(LUNA_RECENT_TOUCH_KEY, JSON.stringify(Object.assign(productPayload(card), {
          session_id: lunaSid,
          touched_at: Date.now()
        })));
      } catch (e) {}
    }
    function recentLunaTouch() {
      try {
        var raw = localStorage.getItem(LUNA_RECENT_TOUCH_KEY);
        if (!raw) return null;
        var touch = JSON.parse(raw);
        if (!touch || !touch.touched_at || Date.now() - touch.touched_at > LUNA_TOUCH_TTL) return null;
        return touch;
      } catch (e) { return null; }
    }
    function trackProductClick(card) {
      rememberLunaTouch(card);
      window.ckLunaTrack('product_view', productPayload(card));
    }

    function imgBox(card, cls) {
      return card.image
        ? el('div', { class: cls }, [el('img', { src: card.image, alt: card.imageAlt || card.title, loading: 'lazy' })])
        : el('div', { class: cls }, [el('span', { class: 'ck-ps__imgph', 'aria-hidden': 'true', text: 'Image' })]);
    }
    function badge(available) { return available ? el('span', { class: 'ck-ps__badge', text: 'In stock' }) : el('span', { class: 'ck-ps__badge ck-ps__badge--out', text: 'Sold out' }); }

    function isMobileChatOnly() {
      return window.matchMedia ? window.matchMedia('(max-width: 900px)').matches : window.innerWidth <= 900;
    }

    function mobileReason(card, index) {
      var specs = card.specs || {};
      var direct = card.reason || card.why || card.take || card.fit || card.summary || card.subtitle || card.description_short;
      if (direct) return direct;
      var best = specs['Best for'] || specs['Best For'] || specs.bestFor || specs.best_for;
      if (best) return 'Best for ' + best + '.';
      var fold = specs.Fold || specs.fold;
      if (fold) return 'Fold: ' + fold + '.';
      return index === 0 ? 'Best first pick based on what you told Luna.' : 'Strong option to compare before you buy.';
    }

    function mobilePickCard(card, index) {
      var add = el('button', { class: 'ck-ps__btn ck-ps__btn--chatadd', type: 'button', text: 'Add to bag' });
      add.addEventListener('click', function () { addToCart(card, add); });
      var actions = [];
      if (card.url) actions.push(el('a', { class: 'ck-ps__btn ck-ps__btn--chatview', href: productUrl(card.url), target: '_top', text: 'View pick', onclick: function () { trackProductClick(card); } }));
      if (defaultVariant(card)) actions.push(add);
      return el('div', { class: 'ck-ps__chatcard' + (index === 0 ? ' ck-ps__chatcard--top' : '') }, [
        el('a', { class: 'ck-ps__chatcardmain', href: productUrl(card.url), target: '_top', onclick: function () { trackProductClick(card); } }, [
          card.image
            ? el('div', { class: 'ck-ps__chatimg' }, [el('img', { src: card.image, alt: card.imageAlt || card.title, loading: 'lazy' })])
            : el('div', { class: 'ck-ps__chatimg' }, [el('span', { class: 'ck-ps__imgph', 'aria-hidden': 'true', text: 'Image' })]),
          el('div', { class: 'ck-ps__chatinfo' }, [
            el('div', { class: 'ck-ps__brandline', text: card.vendor || '' }),
            el('div', { class: 'ck-ps__chatname', text: card.title || 'Recommended pick' }),
            el('div', { class: 'ck-ps__chatmeta' }, [el('span', { class: 'ck-ps__price', text: card.price || '' }), badge(card.available)]),
            el('div', { class: 'ck-ps__chatwhy', text: mobileReason(card, index) }),
          ]),
        ]),
        actions.length ? el('div', { class: 'ck-ps__chatactions' }, actions) : null,
      ]);
    }

    function appendMobileStack(title, children) {
      var stack = el('div', { class: 'ck-ps__chatcards' });
      if (title) stack.appendChild(el('div', { class: 'ck-ps__bubble ck-ps__bubble--cards', text: title }));
      (children || []).forEach(function (child) { if (child) stack.appendChild(child); });
      log.appendChild(el('div', { class: 'ck-ps__msg ck-ps__msg--bot ck-ps__msg--cards' }, [avatar(true), stack]));
      chatScroll();
      return stack;
    }

    function showMobileCards(items, title) {
      items = (items || []).filter(Boolean);
      if (!items.length) return;
      if (mobileCardsShownForTurn) return;
      mobileCardsShownForTurn = true;
      var list = el('div', { class: 'ck-ps__chatcardlist' }, items.slice(0, 3).map(mobilePickCard));
      var tools = el('div', { class: 'ck-ps__chattools' });
      var hidden = items.slice(3, 7);
      if (hidden.length) {
        tools.appendChild(el('button', { class: 'ck-ps__chattool', type: 'button', text: 'Show more', onclick: function (e) {
          hidden.forEach(function (card, offset) { list.appendChild(mobilePickCard(card, offset + 3)); });
          e.currentTarget.remove();
          chatScroll();
        } }));
      }
      if (items.length >= 2) {
        tools.appendChild(el('button', { class: 'ck-ps__chattool', type: 'button', text: 'Compare', onclick: function () {
          window.ckLunaTrack('compare_requested', { surface: surface, products: items.slice(0, 3).map(productPayload) });
          sendMessage('Compare these for me: ' + items.slice(0, 3).map(function (s) { return s.title; }).join(', '));
        } }));
      }
      tools.appendChild(el('button', { class: 'ck-ps__chattool', type: 'button', text: 'Email picks', onclick: function () {
        showEmailForm(items.map(function (s) { return s.handle; }).filter(Boolean));
      } }));
      appendMobileStack(title || "These are my top picks. Tap one when you're ready to look closer.", [list, tools]);
    }

    function trustLine() {
      return el('div', { class: 'ck-ps__trust' }, [el('span', { text: 'Authentic dealer' }), el('span', { text: 'Free shipping' })]);
    }
    function variantPicker(card) {
      var avail = (card.variants || []).filter(function (v) { return v.available; });
      card._variant = avail[0] || (card.variants || [])[0] || null;
      if (avail.length <= 1) return null;
      var wrap = el('div', { class: 'ck-ps__variants' });
      avail.slice(0, 10).forEach(function (v, i) {
        var b = el('button', { class: 'ck-ps__swatch' + (i === 0 ? ' is-sel' : ''), type: 'button', text: v.title, title: v.title });
        b.addEventListener('click', function () { card._variant = v; wrap.querySelectorAll('.ck-ps__swatch').forEach(function (x) { x.classList.remove('is-sel'); }); b.classList.add('is-sel'); });
        wrap.appendChild(b);
      });
      return wrap;
    }
    function shareBtn(card) {
      var b = el('button', { class: 'ck-ps__share', type: 'button', 'aria-label': 'Share this pick', title: 'Share', text: 'Share' });
      b.addEventListener('click', function () {
        window.ckLunaTrack('share', productPayload(card));
        var url = productUrl(card.url);
        if (navigator.share) { navigator.share({ title: card.title, text: 'Check out the ' + card.title + ' at Capital Kidz', url: url }).catch(function () {}); }
        else if (navigator.clipboard) { navigator.clipboard.writeText(url); b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Share'; }, 1800); }
        else { window.prompt('Copy this link:', url); }
      });
      return b;
    }
    function scrollShowIntoView() {
      if (window.innerWidth <= 900 && show && show.scrollIntoView) {
        try { show.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { show.scrollIntoView(); }
      }
    }

    function heroCard(card) {
      var picker = variantPicker(card);
      var add = el('button', { class: 'ck-ps__btn ck-ps__btn--add', type: 'button', text: 'Add to bag' });
      add.addEventListener('click', function () { addToCart(card, add); });
      return el('div', { class: 'ck-ps__hero' }, [
        imgBox(card, 'ck-ps__heroimg'),
        el('div', { class: 'ck-ps__heroinfo' }, [
          el('div', { class: 'ck-ps__herotop' }, [el('span', { class: 'ck-ps__pick', text: "Luna's top pick" }), shareBtn(card)]),
          el('div', { class: 'ck-ps__heroname', text: card.title }),
          el('div', { class: 'ck-ps__brandline', text: card.vendor || '' }),
          el('div', { class: 'ck-ps__herometa' }, [
            el('span', { class: 'ck-ps__price', text: card.price || '' }),
            badge(card.available),
          ]),
          trustLine(),
          picker,
          el('div', { class: 'ck-ps__herobtns' }, [
            add,
            el('a', { class: 'ck-ps__btn ck-ps__btn--view', href: productUrl(card.url), target: '_top', text: 'View details', onclick: function () { trackProductClick(card); } }),
          ]),
        ]),
      ]);
    }

    function gridCard(card) {
      var picker = variantPicker(card);
      var add = el('button', { class: 'ck-ps__btn ck-ps__btn--add', type: 'button', text: 'Add' });
      add.addEventListener('click', function () { addToCart(card, add); });
      return el('div', { class: 'ck-ps__card' }, [
        imgBox(card, 'ck-ps__cardimg'),
        el('div', { class: 'ck-ps__cardbody' }, [
          el('div', { class: 'ck-ps__brandline', text: card.vendor || '' }),
          el('div', { class: 'ck-ps__cardname', text: card.title }),
          el('div', { class: 'ck-ps__cardrow' }, [el('span', { class: 'ck-ps__price', text: card.price || '' }), badge(card.available)]),
          picker,
          el('div', { class: 'ck-ps__cardbtns' }, [add, el('a', { class: 'ck-ps__btn ck-ps__btn--view', href: productUrl(card.url), target: '_top', text: 'View', onclick: function () { trackProductClick(card); } })]),
        ]),
      ]);
    }

    function showEmpty() {
      setShowroomReady(shortlist.length > 0);
      setHead('Your showroom', '');
      clearShow();
      var brands = el('div', { class: 'ck-ps__brands' },
        ['UPPAbaby', 'Doona', 'Britax', 'Chicco', 'BOB', 'Joolz'].map(function (b) { return el('span', { class: 'ck-ps__brandtag', text: b }); }));
      var inner = [
        el('div', { class: 'ck-ps__emptyic', 'aria-hidden': 'true', html: lunaMarkHtml }),
        el('div', { class: 'ck-ps__emptytitle', text: 'Your picks will appear here' }),
        el('div', { class: 'ck-ps__emptytext', text: "Tell Luna about your family and she'll line up the right gear - in stock, with live prices." }),
        brands,
      ];
      var box = el('div', { class: 'ck-ps__empty' }, inner);
      if (cfg.emptyImage) box.style.backgroundImage = 'linear-gradient(rgba(30,47,53,0.45),rgba(30,47,53,0.45)), url(' + cfg.emptyImage + ')';
      if (cfg.emptyImage) box.classList.add('ck-ps__empty--img');
      show.appendChild(box);
    }

    function addToShortlist(items) {
      items.forEach(function (c) { if (c && c.handle && !shortlist.some(function (s) { return s.handle === c.handle; })) shortlist.push(c); });
      renderTray();
      save();
    }

    function showMatches(items) {
      items = (items || []).filter(Boolean);
      if (!items.length) return;
      window.ckLunaTrack('recommendations_shown', { surface: surface, source: 'matches', count: items.length, products: items.slice(0, 8).map(productPayload) });
      if (isMobileChatOnly()) {
        setShowroomReady(false);
        lastMatches = items;
        addToShortlist(items);
        if (show) clearShow();
        showMobileCards(items, "These are my top picks. I'd start here.");
        return;
      }
      setShowroomReady(true);
      lastMatches = items;
      addToShortlist(items);
      setHead('Your matches', items.length + (items.length === 1 ? ' pick' : ' picks') + ' - live prices');
      clearShow();
      show.appendChild(heroCard(items[0]));
      var rest = items.slice(1);
      if (rest.length) show.appendChild(el('div', { class: 'ck-ps__grid' }, rest.map(gridCard)));
      scrollShowIntoView();
    }

    function backLink() {
      return el('button', { class: 'ck-ps__back', type: 'button', text: 'Back to picks', onclick: function () { if (lastMatches.length) showMatches(lastMatches); else showEmpty(); } });
    }
    function stars(r) {
      r = Math.max(0, Math.min(5, r || 0));
      return (Math.round(r * 10) / 10) + '/5';
    }
    function cmpRow(label, values, cellClass) {
      return el('div', { class: 'ck-ps__cmprow' }, [el('div', { class: 'ck-ps__cmplabel', text: label })].concat(
        values.map(function (v) { return el('div', { class: 'ck-ps__cmpcell' + (cellClass ? ' ' + cellClass : ''), text: v }); })));
    }
    function showCompare(data) {
      var items = (data && data.items ? data.items : data || []).filter(Boolean).slice(0, 3);
      if (items.length < 2) return;
      window.ckLunaTrack('compare_shown', { surface: surface, count: items.length, products: items.map(productPayload) });
      if (isMobileChatOnly()) {
        setShowroomReady(false);
        addToShortlist(items);
        if (show) clearShow();
        showMobileCards(items, 'Quick compare: these are the strongest options to look at first.');
        return;
      }
      setShowroomReady(true);
      setHead('Side by side', items.length + ' compared');
      clearShow();
      var rows = (data && data.rows && data.rows.length) ? data.rows : ['Weight', 'Fold', 'Age', 'Best for'];
      var table = el('div', { class: 'ck-ps__cmp' });
      table.style.minWidth = (96 + items.length * 120) + 'px';
      table.appendChild(el('div', { class: 'ck-ps__cmprow ck-ps__cmphead' }, [el('div', { class: 'ck-ps__cmplabel' })].concat(
        items.map(function (c) { return el('div', { class: 'ck-ps__cmpcell' }, [imgBox(c, 'ck-ps__cmpimg'), el('div', { class: 'ck-ps__cmpname', text: c.title }), el('div', { class: 'ck-ps__brandline', text: c.vendor || '' })]); }))));
      table.appendChild(cmpRow("Luna's take", items.map(function (c) { return c.rating ? stars(c.rating) : '-'; }), 'ck-ps__cmprate'));
      table.appendChild(cmpRow('Price', items.map(function (c) { return c.price || '-'; }), 'ck-ps__cmpprice'));
      table.appendChild(cmpRow('Availability', items.map(function (c) { return c.available ? 'In stock' : 'Sold out'; })));
      rows.forEach(function (label) {
        var vals = items.map(function (c) { return (c.specs && c.specs[label]) || ''; });
        if (vals.some(function (v) { return v; })) table.appendChild(cmpRow(label, vals.map(function (v) { return v || '-'; })));
      });
      var actions = el('div', { class: 'ck-ps__cmprow' }, [el('div', { class: 'ck-ps__cmplabel' })].concat(
        items.map(function (c) { var b = el('button', { class: 'ck-ps__btn ck-ps__btn--add', type: 'button', text: 'Add' }); b.addEventListener('click', function () { addToCart(c, b); }); return el('div', { class: 'ck-ps__cmpcell' }, [b]); })));
      table.appendChild(actions);
      show.appendChild(el('div', { class: 'ck-ps__cmpwrap' }, [table]));
      show.appendChild(backLink());
      scrollShowIntoView();
    }

    function showBundle(data) {
      var items = [data.stroller].concat(data.accessories || []).filter(Boolean);
      if (!items.length) return;
      window.ckLunaTrack('bundle_shown', { surface: surface, count: items.length, products: items.slice(0, 8).map(productPayload) });
      if (isMobileChatOnly()) {
        setShowroomReady(false);
        addToShortlist(items);
        if (show) clearShow();
        showMobileCards(items, 'Here is the travel-system set I would start with.');
        return;
      }
      setShowroomReady(true);
      addToShortlist(items);
      setHead('Your travel system', data.totalFormatted ? 'About ' + data.totalFormatted : '');
      clearShow();
      show.appendChild(el('div', { class: 'ck-ps__grid' }, items.map(gridCard)));
      var addAll = el('button', { class: 'ck-ps__btn ck-ps__btn--add ck-ps__btn--wide', type: 'button', text: 'Add all to bag' });
      addAll.addEventListener('click', function () { addAll.disabled = true; addAll.textContent = 'Adding...'; addManyToCart(items, addAll); });
      show.appendChild(addAll);
      show.appendChild(backLink());
      scrollShowIntoView();
    }

    function lastUserRequest() {
      for (var i = messages.length - 1; i >= 0; i--) {
        if (messages[i] && messages[i].role === 'user') return messages[i].content || '';
      }
      return '';
    }

    function chatExcerpt() {
      return messages.slice(-8).map(function (m) {
        return (m.role === 'user' ? 'Shopper: ' : 'Luna: ') + (m.content || '').replace(/\s+/g, ' ').slice(0, 220);
      }).join('\n');
    }

    function showEmailForm(handles) {
      var mobileOnly = isMobileChatOnly();
      var activeHandles = handles && handles.length ? handles : shortlist.map(function (s) { return s.handle; });
      var pickCount = activeHandles.length || shortlist.length;
      window.ckLunaTrack('email_form_opened', { surface: surface, pick_count: pickCount, handles: activeHandles.slice(0, 8) });
      if (!mobileOnly) {
        setShowroomReady(true);
        setHead('Email your picks', '');
        clearShow();
      } else {
        setShowroomReady(false);
        if (show) clearShow();
      }
      var nameIn = el('input', { class: 'ck-ps__email', type: 'text', placeholder: 'First name (optional)', autocomplete: 'given-name' });
      var emailIn = el('input', { class: 'ck-ps__email', type: 'email', placeholder: 'you@email.com', required: 'required' });
      var dueIn = el('input', { class: 'ck-ps__email', type: 'date' });
      var stageIn = el('select', { class: 'ck-ps__email' }, [
        el('option', { value: '', text: 'Shopping stage (optional)' }),
        el('option', { value: 'expecting', text: 'Expecting' }),
        el('option', { value: 'newborn', text: 'Newborn' }),
        el('option', { value: 'infant', text: 'Infant' }),
        el('option', { value: 'toddler', text: 'Toddler' }),
        el('option', { value: 'gift', text: 'Buying a gift' }),
      ]);
      var budgetIn = el('select', { class: 'ck-ps__email' }, [
        el('option', { value: '', text: 'Budget range (optional)' }),
        el('option', { value: 'under-500', text: 'Under $500' }),
        el('option', { value: '500-900', text: '$500-$900' }),
        el('option', { value: '900-1500', text: '$900-$1,500' }),
        el('option', { value: '1500-plus', text: '$1,500+' }),
      ]);
      var consent = el('input', { type: 'checkbox', required: 'required' });
      if (mobileOnly) consent.checked = true;
      var marketing = el('input', { type: 'checkbox' });
      var marketingLabel = el('label', { class: 'ck-ps__consent ck-ps__consent--marketing' }, [marketing, el('span', { text: 'Send me reminders and helpful offers about these picks. I can opt out anytime.' })]);
      var note = el('p');
      var submit = el('button', { class: 'ck-ps__btn ck-ps__btn--add ck-ps__btn--wide', type: 'submit', text: 'Send my picks' });
      var intro = el('div', { class: 'ck-ps__emailintro' }, [
        el('div', { class: 'ck-ps__emailtitle', text: mobileOnly ? 'Send these picks to yourself' : 'Send these picks to your inbox' }),
        el('div', { class: 'ck-ps__emailcopy', text: pickCount ? 'We will send the links, prices, and save them to your Capital Kidz profile so checkout is easier later.' : 'We will send the links and save this to your Capital Kidz profile so you can come back fast.' }),
      ]);
      var mobileFields = [
        intro,
        emailIn,
        nameIn,
        marketingLabel,
        el('div', { class: 'ck-ps__emailassurance', text: 'No password needed. No newsletter unless you tick the box.' }),
        submit, note, backLink(),
      ];
      var desktopFields = [
        intro,
        nameIn,
        emailIn,
        el('label', { class: 'ck-ps__duelabel' }, [el('span', { text: "Baby's birthday or due date (optional) - so Luna can time helpful reminders" }), dueIn]),
        stageIn,
        budgetIn,
        el('label', { class: 'ck-ps__consent' }, [consent, el('span', { text: 'Email me my picks and save them to my Capital Kidz profile.' })]),
        marketingLabel,
        submit, note, backLink(),
      ];
      var f = el('form', { class: 'ck-ps__emailform' + (mobileOnly ? ' ck-ps__emailform--mobile' : '') }, mobileOnly ? mobileFields : desktopFields);
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!mobileOnly && !consent.checked) { note.className = 'ck-ps__err'; note.textContent = 'Please tick the box so we can email you.'; return; }
        submit.disabled = true; submit.textContent = 'Sending...';
        window.ckLunaTrack('lead_submitted', { surface: surface, pick_count: pickCount, handles: activeHandles.slice(0, 8) });
        fetch(base + '/lead', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
          source: 'luna-drawer',
          luna_session_id: lunaSid,
          first_name: nameIn.value.trim() || undefined,
          email: emailIn.value.trim(),
          consent: true,
          marketing_consent: marketing.checked,
          due_date: dueIn.value || undefined,
          shopping_stage: stageIn.value || undefined,
          budget_range: budgetIn.value || undefined,
          last_request: lastUserRequest(),
          chat_excerpt: chatExcerpt(),
          recommended_handles: activeHandles
        }) })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.ok) {
              note.className = 'ck-ps__note';
              note.textContent = 'Sent to ' + emailIn.value.trim() + '. Check your inbox.';
              submit.textContent = 'Sent';
            } else if (d && d.lead_saved) {
              note.className = 'ck-ps__err';
              note.textContent = 'I saved your list, but the email did not send. Tap a pick to keep shopping.';
              submit.disabled = false;
              submit.textContent = 'Try again';
            } else {
              note.className = 'ck-ps__err';
              note.textContent = "That didn't go through - try again?";
              submit.disabled = false;
              submit.textContent = 'Send my picks';
            }
          })
          .catch(function () { note.className = 'ck-ps__err'; note.textContent = 'Network hiccup - try again?'; submit.disabled = false; submit.textContent = 'Send my picks'; });
      });
      var panel = el('div', { class: 'ck-ps__panelcard ck-ps__emailpanel' }, [f]);
      if (mobileOnly) appendMobileStack('Want the links for later?', [panel]);
      else show.appendChild(panel);
    }

    function renderTray() {
      if (!shortlist.length) { tray.hidden = true; tray.innerHTML = ''; return; }
      if (isMobileChatOnly()) { tray.hidden = true; tray.innerHTML = ''; return; }
      tray.hidden = false;
      tray.innerHTML = '';
      var thumbs = el('div', { class: 'ck-ps__thumbs' }, shortlist.slice(0, 6).map(function (c) {
        return el('button', { class: 'ck-ps__thumb', type: 'button', title: c.title, 'aria-label': c.title, onclick: function () { showMatches([c]); } },
          [c.image ? el('img', { src: c.image, alt: c.title, loading: 'lazy' }) : el('span', { 'aria-hidden': 'true', text: 'Image' })]);
      }));
      var actions = el('div', { class: 'ck-ps__trayactions' }, []);
      if (shortlist.length >= 2) actions.appendChild(el('button', { class: 'ck-ps__traybtn', type: 'button', text: 'Compare', onclick: function () { sendMessage('Compare these for me: ' + shortlist.slice(0, 3).map(function (s) { return s.title; }).join(', ')); } }));
      actions.appendChild(el('button', { class: 'ck-ps__traybtn', type: 'button', text: 'Email picks', onclick: function () { showEmailForm(shortlist.map(function (s) { return s.handle; })); } }));
      tray.appendChild(el('div', { class: 'ck-ps__traylabel' }, [el('span', { text: 'Shortlist' }), el('span', { class: 'ck-ps__traycount', text: shortlist.length + '' })]));
      tray.appendChild(thumbs);
      tray.appendChild(actions);
    }

    // ===================== cart =====================
    function addToCart(card, btn) {
      var v = card._variant || defaultVariant(card); if (!v || !v.variantId) return;
      btn.disabled = true; btn.textContent = 'Adding...';
      internalCartAddUntil = Date.now() + 1500;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.variantId, quantity: 1, properties: { _luna_assisted: 'yes', _luna_session_id: lunaSid, _luna_handle: card.handle || '' } }) })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function () { window.ckLunaTrack('add_to_cart', productPayload(card)); markCartLuna(); btn.textContent = 'Added'; document.dispatchEvent(new CustomEvent('cart:refresh')); document.dispatchEvent(new CustomEvent('ajaxProduct:added')); })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add to bag'; window.location.href = card.url; });
    }
    function addManyToCart(cards, btn) {
      var items = cards.map(function (c) { var v = c._variant || defaultVariant(c); return v ? { id: v.variantId, quantity: 1, properties: { _luna_assisted: 'yes', _luna_session_id: lunaSid, _luna_handle: c.handle || '' } } : null; }).filter(Boolean);
      internalCartAddUntil = Date.now() + 1500;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function () { window.ckLunaTrack('add_all_to_cart', { surface: surface, count: cards.length, products: cards.slice(0, 8).map(productPayload) }); markCartLuna(); btn.textContent = 'Added'; document.dispatchEvent(new CustomEvent('cart:refresh')); })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add all to bag'; window.location.href = '/cart'; });
    }
    function markCartLuna(touch) {
      touch = touch || {};
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Luna assisted': 'yes', 'Luna session': touch.session_id || lunaSid, 'Luna last touch': new Date().toISOString(), 'Luna product': touch.handle || '' } }),
          keepalive: true
        }).catch(function () {});
      } catch (e) {}
    }
    function maybeMarkExternalCartAdd(trigger) {
      if (Date.now() < internalCartAddUntil || Date.now() - lastExternalCartMark < 1500) return;
      var touch = recentLunaTouch();
      if (!touch) return;
      lastExternalCartMark = Date.now();
      window.ckLunaTrack('add_to_cart', Object.assign({}, touch, { surface: 'product_page', trigger: trigger || 'unknown' }));
      markCartLuna(touch);
    }
    if (!window.__ckLunaCartListeners) {
      window.__ckLunaCartListeners = true;
      document.addEventListener('ajaxProduct:added', function () { maybeMarkExternalCartAdd('ajaxProduct:added'); });
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.getAttribute) return;
        var action = f.getAttribute('action') || '';
        if (action.indexOf('/cart/add') >= 0) setTimeout(function () { maybeMarkExternalCartAdd('cart_add_form'); }, 350);
      }, true);
    }

    // ===================== streaming =====================
    function parseEvent(chunk) {
      var ev = 'message', data = '';
      chunk.split('\n').forEach(function (line) {
        if (line.indexOf('event:') === 0) ev = line.slice(6).trim();
        else if (line.indexOf('data:') === 0) { var d = line.slice(5); if (d.charAt(0) === ' ') d = d.slice(1); data += d; }
      });
      var p = {}; try { p = data ? JSON.parse(data) : {}; } catch (e) {}
      return { event: ev, data: p };
    }

    function sendMessage(text) {
      if (busy || !text) return;
      window.ckLunaTrack('message_sent', { surface: surface, length: String(text).length });
      mobileCardsShownForTurn = false;
      busy = true; send.disabled = true; input.disabled = true;
      if (suggestWrap) suggestWrap.style.display = 'none';
      if (currentQuick) { currentQuick.remove(); currentQuick = null; }

      addMsg('user', text);
      messages.push({ role: 'user', content: text });

      var typing = addTyping();
      var bubble = null, acc = '', statusEl = null;
      function ensureBubble() { if (!bubble) { if (typing) { typing.remove(); typing = null; } bubble = addMsg('bot', ''); } return bubble; }
      function setStatus(t) { if (!statusEl) { statusEl = el('div', { class: 'ck-ps__status' }); log.appendChild(statusEl); } statusEl.textContent = t; chatScroll(); }
      function clearStatus() { if (statusEl) { statusEl.remove(); statusEl = null; } }

      if (!base) { ensureBubble().textContent = "I'm not fully connected yet - please use the contact form for now."; finish(); return; }

      fetch(base + '/chat', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages: messages, turnstileToken: turnstileToken }) })
        .then(function (resp) {
          if (!resp.body) throw new Error('no stream');
          var reader = resp.body.getReader(), dec = new TextDecoder(), buf = '';
          function pump() {
            return reader.read().then(function (res) {
              if (res.done) return finish();
              buf += dec.decode(res.value, { stream: true });
              var idx;
              while ((idx = buf.indexOf('\n\n')) >= 0) { var chunk = buf.slice(0, idx); buf = buf.slice(idx + 2); if (chunk.trim()) onEvent(parseEvent(chunk)); }
              return pump();
            });
          }
          return pump();
        })
        .catch(function () { ensureBubble().textContent = 'Sorry - I lost my connection. Please try again, or use the contact form.'; finish(); });

      function onEvent(e) {
        var d = e.data || {};
        switch (e.event) {
          case 'text': clearStatus(); ensureBubble(); acc += d; bubble.innerHTML = mdToHtml(acc); chatScroll(); break;
          case 'status': setStatus(d.text || '...'); break;
          case 'notice': clearStatus(); ensureBubble().textContent = d.text || ''; acc = d.text || ''; break;
          case 'error': clearStatus(); ensureBubble().textContent = d.text || 'Something went wrong.'; break;
          case 'quick_replies': clearStatus(); ensureBubble(); renderQuickReplies(d.options || []); break;
          case 'handoff': clearStatus(); renderHandoff(d); break;
          case 'cards': clearStatus(); showMatches(d.items || []); break;
          case 'compare': clearStatus(); showCompare(d); break;
          case 'bundle': clearStatus(); showBundle(d); break;
          case 'email_capture': clearStatus(); showEmailForm(d.handles || []); break;
          case 'done': finish(); break;
        }
      }

      var finished = false;
      function finish() {
        if (finished) return; finished = true;
        clearStatus();
        if (typing) { typing.remove(); typing = null; }
        if (acc.trim()) {
          messages.push({ role: 'assistant', content: acc });
          if (bubble) addFeedbackControls(bubble, acc);
        }
        save();
        busy = false; send.disabled = false; input.disabled = false; input.focus();
      }
    }

    // ===================== wire up =====================
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = (input.value || '').trim();
      if (!t) return;
      input.value = '';
      sendMessage(t);
    });
    if (suggestWrap) suggestWrap.querySelectorAll('[data-ps-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () { var choice = chip.textContent.trim(); window.ckLunaTrack('quick_reply', { surface: surface, choice: choice }); sendMessage(choice); });
    });

    var saved = loadSaved();
    if (saved) {
      shortlist = saved.shortlist || [];
      messages = saved.messages || [];
      messages.slice(-10).forEach(function (m) {
        if (m.role === 'user') addMsg('user', m.content);
        else { var b = addMsg('bot', ''); b.innerHTML = mdToHtml(m.content); }
      });
      renderTray();
      if (saved.lastMatches && saved.lastMatches.length) { lastMatches = saved.lastMatches; showMatches(saved.lastMatches); }
      else showEmpty();
      addMsg('bot', "Welcome back! I saved your picks from last time - want to keep going, compare them, or have them emailed?");
    } else {
      showEmpty();
      addMsg('bot', cfg.introMessage || "Hi, I'm Luna, your personal shopper at Capital Kidz. I can help you find the right stroller or travel system, compare options, even build a full travel system - and I only show what's in stock. What are you shopping for today?");
    }
  }

  function launcherTrack(event, data) {
    if (window.ckLunaTrack) window.ckLunaTrack(event, Object.assign({ surface: 'launcher' }, data || {}));
  }

  function launcherSetDrawerState(root, isOpen) {
    var drawer = root && root.querySelector('[data-luna-drawer]');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (isOpen) drawer.removeAttribute('inert');
    else drawer.setAttribute('inert', '');
  }

  function launcherHideTeaser(root) {
    var teaser = root && root.querySelector('[data-luna-teaser]');
    if (teaser) teaser.classList.remove('is-shown');
  }

  function launcherOpen(root) {
    if (!root) return;
    launcherHideTeaser(root);
    root.classList.add('is-open');
    launcherTrack('open');
    launcherSetDrawerState(root, true);
    document.body.style.overflow = 'hidden';
    var i = root.querySelector('[data-ps-input]');
    if (i) setTimeout(function () { i.focus(); }, 320);
  }

  function launcherClose(root) {
    if (!root) return;
    root.classList.remove('is-open');
    launcherTrack('close');
    launcherSetDrawerState(root, false);
    document.body.style.overflow = '';
  }

  function initLauncher(root) {
    if (!root || root.__ckLauncherInit) return;
    root.__ckLauncherInit = true;

    var openBtn = root.querySelector('[data-luna-open]');
    var closeBtn = root.querySelector('[data-luna-close]');
    var overlay = root.querySelector('[data-luna-overlay]');
    var drawer = root.querySelector('[data-luna-drawer]');
    var teaser = root.querySelector('[data-luna-teaser]');
    var teaserClose = root.querySelector('[data-luna-teaser-close]');
    var TKEY = 'ckLunaTeaserDismissed';
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 600px)').matches;

    function setDrawerState(isOpen) { launcherSetDrawerState(root, isOpen); }
    function teaserDismissed() {
      try {
        var v = localStorage.getItem(TKEY);
        return v && (Date.now() - parseInt(v, 10) < 7 * 864e5);
      } catch (e) { return false; }
    }
    function hideTeaser() { launcherHideTeaser(root); }
    function track(event, data) { launcherTrack(event, data); }
    function showTeaser() {
      if (isMobile || !teaser || root.classList.contains('is-open') || teaserDismissed()) return;
      teaser.classList.add('is-shown');
      track('teaser_shown');
      setTimeout(hideTeaser, 14000);
    }
    function open() {
      launcherOpen(root);
    }
    function close() {
      launcherClose(root);
    }

    setDrawerState(false);
    if (openBtn && root.getAttribute('data-ck-human-first') !== 'true') openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    if (teaser) teaser.addEventListener('click', function (e) {
      if (e.target.closest('[data-luna-teaser-close]')) return;
      open();
    });
    if (teaserClose) teaserClose.addEventListener('click', function (e) {
      e.stopPropagation();
      hideTeaser();
      track('teaser_dismissed');
      try { localStorage.setItem(TKEY, '' + Date.now()); } catch (e2) {}
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    if (document.querySelector('section.ck-ps')) {
      var b = root.querySelector('.ck-luna__bubble');
      if (b) b.style.display = 'none';
    } else {
      try {
        if (!sessionStorage.getItem('ckLunaTeaserShown')) {
          sessionStorage.setItem('ckLunaTeaserShown', '1');
          setTimeout(showTeaser, 5000);
        }
      } catch (e3) {}
    }
  }

  if (!window.__ckLunaLauncherDelegated) {
    window.__ckLunaLauncherDelegated = true;
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var openTarget = e.target.closest('[data-luna-open]');
      if (openTarget) {
        var openRoot = openTarget.closest('[data-ck-luna]');
        if (openRoot && openRoot.getAttribute('data-ck-human-first') === 'true') return;
        if (openRoot) {
          e.preventDefault();
          e.stopPropagation();
          launcherOpen(openRoot);
        }
        return;
      }
      var closeTarget = e.target.closest('[data-luna-close], [data-luna-overlay]');
      if (closeTarget) {
        var closeRoot = closeTarget.closest('[data-ck-luna]') || document.querySelector('[data-ck-luna].is-open');
        if (closeRoot) {
          e.preventDefault();
          e.stopPropagation();
          launcherClose(closeRoot);
        }
      }
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var root = document.querySelector('[data-ck-luna].is-open');
      if (root) launcherClose(root);
    });
  }

  function lunaLogoUrl() {
    var script = document.querySelector('script[src*="/assets/ck-personal-shopper.js"]');
    var src = script ? script.src : '';
    if (src.indexOf('/assets/') !== -1) return src.split('/assets/')[0] + '/assets/ck-luna-textured-logo.png';
    return '/cdn/shop/t/9/assets/ck-luna-textured-logo.png';
  }

  function applyTexturedLunaLogo(root) {
    if (!root) return;
    var url = lunaLogoUrl();
    var targets = [
      ['.ck-luna__bubavatar', 40],
      ['.ck-luna__teaseravatar', 24],
      ['.ck-luna__baravatar', 32]
    ];
    targets.forEach(function (item) {
      var node = root.querySelector(item[0]);
      if (!node) return;
      node.innerHTML = '<img class="ck-luna__logo" src="' + url + '" alt="" width="' + item[1] + '" height="' + item[1] + '" loading="eager">';
    });
    root.querySelectorAll('.ck-luna__aibadge').forEach(function (badge) { badge.remove(); });
    var button = root.querySelector('.ck-luna__bubble');
    if (button) button.setAttribute('aria-label', root.getAttribute('data-ck-human-first') === 'true' ? 'Chat with Capital Kidz' : 'Chat with Luna, your personal shopper');
    if (!document.getElementById('ck-luna-textured-logo-runtime-style')) {
      var style = document.createElement('style');
      style.id = 'ck-luna-textured-logo-runtime-style';
      style.textContent = '.ck-luna__bubavatar,.ck-luna__teaseravatar,.ck-luna__baravatar{background:transparent!important;overflow:hidden}.ck-luna__logo{display:block;width:100%;height:100%;border-radius:50%;object-fit:cover}.ck-luna .ck-ps__avatar{background:transparent url("' + url + '") center/cover no-repeat!important;overflow:hidden}.ck-luna .ck-ps__avatar .ck-ps__mark{display:none!important}@media(max-width:600px){.ck-luna__bubavatar{width:44px!important;height:44px!important}}';
      document.head.appendChild(style);
    }
  }

  function fitShopifyChatWidget() {
    if (window.__ckWidgetFitActive) return;
    window.__ckWidgetFitActive = true;

    var mobileMq = window.matchMedia('(max-width: 749px)');
    var scheduled = false;
    var observedWidget = null;
    var observedToggleRoot = null;
    var widgetObserver = null;
    var widgetShadowObserver = null;

    function stickyCartOffset() {
      if (!mobileMq.matches) return null;
      var stickyCart = document.querySelector('.ck-sticky-cart');
      if (!stickyCart) return null;
      var rect = stickyCart.getBoundingClientRect();
      var offset = Math.max(76, Math.ceil((rect.height || 62) + 14));
      return 'calc(' + offset + 'px + env(safe-area-inset-bottom, 0px))';
    }

    function bottomOffset() {
      if (document.getElementById('PBarNextFrameWrapper')) {
        return 'calc(88px + env(safe-area-inset-bottom, 0px))';
      }
      var stickyOffset = stickyCartOffset();
      if (stickyOffset) return stickyOffset;
      return mobileMq.matches ? 'max(14px, env(safe-area-inset-bottom, 0px))' : '20px';
    }

    function setImportant(node, property, value) {
      if (
        node.style.getPropertyValue(property) !== value ||
        node.style.getPropertyPriority(property) !== 'important'
      ) {
        node.style.setProperty(property, value, 'important');
      }
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        apply();
      });
    }

    function observeWidget(widget) {
      if (!widget || !window.MutationObserver) return;
      if (observedWidget !== widget) {
        if (widgetObserver) widgetObserver.disconnect();
        if (widgetShadowObserver) widgetShadowObserver.disconnect();
        observedWidget = widget;
        observedToggleRoot = null;
        widgetShadowObserver = null;
        widgetObserver = new MutationObserver(schedule);
        widgetObserver.observe(widget, { attributes: true, attributeFilter: ['style', 'class', 'is-open'] });
      }
      var toggle = window.ckGetShopifyInboxToggle(widget);
      var toggleRoot = toggle && toggle.getRootNode ? toggle.getRootNode() : widget.shadowRoot;
      if (toggleRoot && observedToggleRoot !== toggleRoot) {
        if (widgetShadowObserver) widgetShadowObserver.disconnect();
        observedToggleRoot = toggleRoot;
        widgetShadowObserver = new MutationObserver(schedule);
        widgetShadowObserver.observe(toggleRoot, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['aria-expanded']
        });
      }
    }

    function isModernWidget(widget) {
      return widget.tagName === 'SHOPIFY-CHAT' || widget.tagName === 'SHOPIFY-AGENT';
    }

    function isExpanded(widget) {
      var shadowToggle = window.ckGetShopifyInboxToggle(widget);
      if (shadowToggle) return shadowToggle.getAttribute('aria-expanded') === 'true';
      var openState = widget.getAttribute('is-open');
      if (openState === 'true') return true;
      if (openState === 'false') return false;
      var style = widget.getAttribute('style') || '';
      var rect = widget.getBoundingClientRect();
      return /height:\s*100%/i.test(style) || rect.height > 140 || rect.width > 280;
    }

    function apply() {
      var widget = document.querySelector('#ShopifyChat, inbox-online-store-chat, shopify-chat, shopify-agent');
      if (!widget) return false;
      observeWidget(widget);
      var unifiedConcierge = !!document.querySelector('[data-ck-concierge-unified="true"]');

      // Shopify's modern web component already owns its panel geometry.
      // Only synchronize Luna's visibility; do not resize, transform, or hide the host.
      if (isModernWidget(widget)) {
        var modernExpanded = isExpanded(widget);
        document.documentElement.classList.toggle('ck-human-chat-open', modernExpanded);
        document.querySelectorAll('[data-ck-luna]').forEach(function (root) {
          if (modernExpanded) setImportant(root, 'display', 'none');
          else root.style.removeProperty('display');
        });
        widget.setAttribute('data-ck-widget-fit', modernExpanded ? 'open' : 'native-launcher-hidden');
        return true;
      }

      if (isExpanded(widget)) {
        document.documentElement.classList.add('ck-human-chat-open');
        document.querySelectorAll('[data-luna-open]').forEach(function (button) {
          setImportant(button, 'display', 'none');
        });
        setImportant(widget, 'z-index', '2147483500');
        setImportant(widget, 'transform', 'none');
        setImportant(widget, 'transform-origin', 'center center');
        setImportant(widget, 'opacity', '1');
        setImportant(widget, 'visibility', 'visible');
        setImportant(widget, 'pointer-events', 'auto');
        if (mobileMq.matches) {
          setImportant(widget, 'top', '0');
          setImportant(widget, 'left', '0');
          setImportant(widget, 'right', '0');
          setImportant(widget, 'bottom', '0');
          setImportant(widget, 'width', '100vw');
          setImportant(widget, 'min-width', '100vw');
          setImportant(widget, 'max-width', '100vw');
          setImportant(widget, 'height', '100dvh');
          setImportant(widget, 'max-height', '100dvh');
          setImportant(widget, 'box-sizing', 'border-box');
        } else if (isModernWidget(widget)) {
          [
            'top', 'left', 'right', 'bottom', 'width', 'min-width', 'max-width',
            'height', 'max-height', 'box-sizing'
          ].forEach(function (property) {
            widget.style.removeProperty(property);
          });
        } else {
          setImportant(widget, 'top', 'auto');
          setImportant(widget, 'left', 'auto');
          setImportant(widget, 'right', '20px');
          setImportant(widget, 'bottom', '20px');
        }
        widget.setAttribute('data-ck-widget-fit', 'open');
        return true;
      }

      document.documentElement.classList.remove('ck-human-chat-open');
      document.querySelectorAll('[data-luna-open]').forEach(function (button) {
        button.style.removeProperty('display');
      });
      if (unifiedConcierge) {
        if (isModernWidget(widget)) {
          [
            'top', 'left', 'right', 'bottom', 'width', 'min-width', 'max-width',
            'height', 'max-height', 'box-sizing', 'z-index', 'transform-origin'
          ].forEach(function (property) {
            widget.style.removeProperty(property);
          });
          setImportant(widget, 'transform', 'none');
          setImportant(widget, 'opacity', '0');
          setImportant(widget, 'visibility', 'hidden');
          setImportant(widget, 'pointer-events', 'none');
        } else {
          setImportant(widget, 'top', 'auto');
          setImportant(widget, 'left', '0');
          setImportant(widget, 'right', 'auto');
          setImportant(widget, 'bottom', '0');
          setImportant(widget, 'width', '65px');
          setImportant(widget, 'min-width', '0');
          setImportant(widget, 'max-width', 'none');
          setImportant(widget, 'height', '65px');
          setImportant(widget, 'max-height', 'none');
          setImportant(widget, 'transform', 'scale(0.01)');
          setImportant(widget, 'transform-origin', 'bottom left');
          setImportant(widget, 'opacity', '0');
          setImportant(widget, 'visibility', 'visible');
          setImportant(widget, 'pointer-events', 'none');
        }
        widget.setAttribute('data-ck-widget-fit', 'unified-hidden');
        return true;
      }

      if (mobileMq.matches) {
        setImportant(widget, 'left', '16px');
        setImportant(widget, 'right', 'auto');
        setImportant(widget, 'bottom', bottomOffset());
        setImportant(widget, 'transform', 'scale(0.8)');
      } else {
        setImportant(widget, 'left', '20px');
        setImportant(widget, 'right', 'auto');
        setImportant(widget, 'bottom', bottomOffset());
        setImportant(widget, 'transform', 'scale(0.92)');
      }

      setImportant(widget, 'transform-origin', 'bottom left');
      setImportant(widget, 'opacity', '1');
      setImportant(widget, 'visibility', 'visible');
      setImportant(widget, 'pointer-events', 'auto');
      widget.setAttribute('data-ck-widget-fit', 'true');
      return true;
    }

    apply();
    if (window.MutationObserver && document.documentElement) {
      new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    }
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);

    var attempts = 0;
    var timer = setInterval(function () {
      apply();
      attempts += 1;
      if (attempts > 160) clearInterval(timer);
    }, 250);
  }

  function boot() {
    fitShopifyChatWidget();
    document.querySelectorAll('[data-ck-ps]').forEach(initRoot);
    document.querySelectorAll('[data-ck-luna]').forEach(initLauncher);
    document.querySelectorAll('[data-ck-luna]').forEach(applyTexturedLunaLogo);
    setTimeout(function () { document.querySelectorAll('[data-ck-luna]').forEach(applyTexturedLunaLogo); }, 500);
    setTimeout(function () { document.querySelectorAll('[data-ck-luna]').forEach(applyTexturedLunaLogo); }, 2000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

